import { createStore } from 'vuex'
export default createStore({
  state: {
    user: 'Kamil Nowak',
  },
  mutations: {},
  actions: {},
  modules: {},
})
